interface CombineSizeLengthParams {
    /** The size name (e.g. waist for jeans, or a plain size like "M"). */
    size: string | null;
    /** The length name, when the size has one (e.g. jeans leg length). */
    length: string | null;
}

/**
 * Builds a human-readable size label. When a length is present the value is a
 * jeans-style `W{size}/L{length}` (the inch mark is stripped from the length);
 * otherwise it is just the size. Returns `null` when there is no size.
 */
const combineSizeLength = ({
    size,
    length,
}: CombineSizeLengthParams): string | null => {
    if (!size) return null;
    return length ? `W${size}/L${length.replace(/\D/g, '')}` : size;
};

export { combineSizeLength };
export type { CombineSizeLengthParams };
